// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__MdBJg","label":"Category_label__3h1zG","content":"Category_content__STSPk","header":"Category_header__V59z8","location":"Category_location__SvSg_"};